import * as firebase from 'firebase';

export function removeEventFnc(firestore, event_title, user, noFetchData) {
  const event = firestore.collection("Event").doc(event_title);
  firestore.collection("Users").doc(user.email).update({
      events: firebase.firestore.FieldValue.arrayRemove(event)
  }).then(() => {
      noFetchData();
  });
}